import { toSnakeCase } from './string'

export const MODULE_ID_SEPARATOR = '::'
export const MODULE_VARIANT_SEPARATOR = '--'
export const FIRST_MODULE_ID = '@@TOP'

export const toSiblingMap = (siblingSelectors = []) =>
  siblingSelectors.reduce((acc, it) => {
    const keyArr = it.key.map((i) => {
      if (typeof i === 'string') {
        return i
      }
      const { module, variant, layout } = i
      return [module, toSnakeCase(variant || layout)].filter(Boolean).join(MODULE_VARIANT_SEPARATOR)
    })
    return { ...acc, [keyArr.join(MODULE_ID_SEPARATOR)]: it }
  }, {})

/* eslint-disable-next-line */
export const __example__devModuleIds = ['palette', 'spacingOverride']

/* eslint-disable-next-line */
export const __example__siblingSpacing = [
  {
    key: [FIRST_MODULE_ID, 'breadcrumb'],
    spacing: [{}, { spacingTop: 'sm' }],
  },
  {
    key: [FIRST_MODULE_ID, 'cta'],
    spacing: [{}, { spacingTop: 'sm' }, {}],
  },
  {
    key: [FIRST_MODULE_ID, 'authorProfile'],
    spacing: [{}, { spacingTop: 'xl' }],
  },
  {
    key: ['hero', 'paragraph'],
    spacing: [{ spacingBottom: ['lg', 'xl'] }, {}],
  },
  {
    key: ['button', 'widgetHtml'],
    spacing: [{ spacingTop: ['md', 'xl'] }, {}],
  },
  {
    key: ['hero', 'collectionModule'],
    spacing: [{}, { spacingTop: ['md', 'lg'], spacingBottom: ['md', 'lg'] }],
  },
  {
    key: ['@@TOP', 'embedded-asset-block'],
    spacing: [{}, { spacingTop: ['lg', 'xl'] }],
  },
  {
    key: ['imageModule', 'richTextBlock'],
    spacing: [{ spacingBottom: ['sm', 'md'] }, {}],
  },
  {
    key: ['heading-1', 'leadCaptureForm'],
    spacing: [{}, { spacingTop: 'md', spacingBottom: 'md' }],
  },
  {
    key: ['contentHeroModule', 'heading-2'],
    spacing: [{ spacingBottom: ['lg', 'xl'] }, {}],
  },
  {
    key: ['readMoreModule', 'author'],
    spacing: [{}, { spacingTop: 24 }],
  },
  {
    key: ['categoryHeadingModule', 'authorProfile'],
    spacing: [{}, { spacingTop: 64 }],
  },
  {
    key: ['categoryGuidesModule', 'categoryGuidesModule'],
    spacing: [{ spacingTop: ['md', 'lg'], spacingBottom: ['md', 'xl'] }, {}],
  },
  {
    key: ['linkList', 'categoryGuidesModule'],
    // eslint-disable-next-line no-magic-numbers
    spacing: [{ spacingBottom: [32, 88] }, {}],
  },
  {
    key: ['linkWithLabel', 'accordion'],
    spacing: [{ spacingBottom: 200 }, { spacingTop: 200 }],
  },
  {
    key: ['breadcrumb', 'linkWithLabel'],
    spacing: [{ spacingBottom: 200 }, { spacingTop: 200 }],
  },
  {
    key: [{ module: 'widgetHtml', variant: 'trustpilotHorizontal' }, 'richTextBlock'],
    spacing: [{}, { spacingTop: 'lg' }],
  },
  {
    key: ['categoryHeadingModule', 'callOut'],
    spacing: [{}, { spacingTop: 'xs' }],
  },
  {
    key: ['callOut', 'productTable'],
    spacing: [{ spacingBottom: 'md' }],
  },
  {
    key: ['hero', 'richTextModule'],
    spacing: [{}, { spacingTop: 'md' }],
  },
  {
    key: ['imageModule', 'paragraph'],
    spacing: [{ spacingBottom: 'md' }, {}],
  },
  {
    key: ['imageModule', 'heading-1'],
    spacing: [{ spacingBottom: 'base' }, {}],
  },
  {
    key: ['imageModule', 'heading-4'],
    spacing: [{ spacingBottom: 'base' }, {}],
  },
  {
    key: ['imageModule', 'heading-5'],
    spacing: [{ spacingBottom: 'base' }, {}],
  },
  {
    key: ['imageModule', 'heading-6'],
    spacing: [{ spacingBottom: 'base' }, {}],
  },
  {
    key: ['heading-3', 'imageModule'],
    spacing: [{ spacingBottom: 'md' }, {}],
  },
  {
    key: ['table', 'richTextModule'],
    spacing: [{ spacingTop: 'lg', spacingBottom: 'lg' }, {}],
  },
]
